const CURRENT_APP = process.env.REACT_APP_APPLICATION_NAME

export default CURRENT_APP
